export default __webpack_public_path__ + "static/media/toddlers.65843f34.jpeg";